// Based on src\app\shared\services\api-journey-planner\models\enumerations.ts
export enum LocationType {
  unknown = 'unknown',
  stopArea = 'stoparea',
  stopPoint = 'stoppoint',
  address = 'address',
  pointOfInterest = 'pointofinterest',
  metaStation = 'metastation',
  // currentPosition = 'currentPosition', // NOT an actual api journey planner type. Do not use against api journey planner
}
